import { useState } from "react";
import { useTheme } from "@/lib/theme-context";
import { useI18n } from "@/lib/i18n";
import { X } from "lucide-react";

export function TopBar() {
  const theme = useTheme();
  const { lang } = useI18n();
  const [dismissed, setDismissed] = useState(false);

  if (theme?.topBarEnabled !== "true" || dismissed) return null;

  const text = lang === "ar" ? (theme?.topBarTextAr || theme?.topBarText || "") : (theme?.topBarText || "");
  if (!text) return null;

  const dismissible = theme?.topBarDismissible !== "false";
  const scroll = theme?.topBarScroll === "true";

  return (
    <div
      className="relative flex items-center justify-center gap-2 py-2 px-8 text-center overflow-hidden"
      style={{
        backgroundColor: theme?.topBarBg || "#000",
        color: theme?.topBarTextColor || "#fff",
      }}
    >
      <span className={`text-[11px] tracking-wider font-medium ${scroll ? "animate-marquee whitespace-nowrap" : ""}`}>
        {text}
      </span>
      {dismissible && (
        <button
          onClick={() => setDismissed(true)}
          className="absolute end-3 top-1/2 -translate-y-1/2 opacity-85 hover:opacity-100 transition-opacity min-w-[44px] min-h-[44px] flex items-center justify-center"
          aria-label={lang === "ar" ? "إغلاق" : "Dismiss"}
        >
          <X className="h-3 w-3" aria-hidden="true" />
        </button>
      )}
      {scroll && (
        <style>{`@keyframes marquee { 0% { transform: translateX(100%); } 100% { transform: translateX(-100%); } } .animate-marquee { animation: marquee 15s linear infinite; }`}</style>
      )}
    </div>
  );
}
